<template>
  <div :class="$style.container">
    <div :class="$style.status">
      <base-icon
        v-color:black-2
        name="basic_eagle"
      />
    </div>

    <div :class="$style.content">
      <base-loader />
    </div>
  </div>
</template>

<script>
import BaseLoader from 'atoms/base/BaseLoader';

export default {
  name: 'TransactionDeclaring',
  components: {
    BaseLoader,
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +align-items(center)
    +size(100%, auto)

  .status
    +flexbox
    margin-right: 26px

  .content
    +flex-grow
</style>
